import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { formatDateTime } from '../../../../util/datetime'
import CustomerLink from '../../../customer/component/CustomerLink'
import { BACKEND_URL } from '../../../../util/api'

const LABEL_URL = BACKEND_URL + '/api/sales-order/view-set-label?salesOrderId='
const LABEL_REFINEMENT_URL = BACKEND_URL + '/api/sales-order/view-refinement-set-label?salesOrderId='
const ALIGNER_LABEL_URL = BACKEND_URL + '/api/production/render-aligner-label-pdf?salesOrderId='
const REPRODUCTION_ALIGNER_LABEL_URL = BACKEND_URL + '/api/production/render-reproduction-aligner-label-pdf?salesOrderId='
const RETAINER_LABEL_URL = BACKEND_URL + '/api/production/render-retainer-label-pdf?salesOrderId='

const SalesOrderProcessInfoTable = ({ salesOrder, showInitialProcess, hasPreviousRetainerRefinementProcess }) => {
    return (
        <table className="sales-order-info-table">
            <tbody>
                <tr>
                    <td>Customer</td>
                    <td><CustomerLink customer={salesOrder.customer}/></td>
                </tr>
                <tr>
                    <td>Sales Order</td>
                    <td><Link to={'/sales-order/edit/' + salesOrder.id}>{salesOrder.referenceNumber}</Link></td>
                </tr>
                <tr>
                    <td>Created</td>
                    <td>{formatDateTime(salesOrder.created)}</td>
                </tr>
                <tr>
                    <td>Reference Number</td>
                    <td>{salesOrder.referenceNumber}</td>
                </tr>
                {
                    (salesOrder.type === 'set') && (
                        <tr>
                            <td>Set Label</td>
                            <td><a href={LABEL_URL + salesOrder.id} target="_blank" rel="noopener noreferrer">open</a></td>
                        </tr>
                    )
                }
                {
                    (salesOrder.type === 'refinement-set') && (
                        <tr>
                            <td>Refinement Label</td>
                            <td><a href={LABEL_REFINEMENT_URL + salesOrder.id} target="_blank" rel="noopener noreferrer">open</a></td>
                        </tr>
                    )
                }
                {
                    (salesOrder.type === 'treatment' || salesOrder.type === 'treatment-new' || salesOrder.type === 'refinement-production') && (
                        <tr>
                            <td>Aligner Label</td>
                            <td><a href={ALIGNER_LABEL_URL + salesOrder.id} target="_blank" rel="noopener noreferrer">open</a></td>
                        </tr>
                    )
                }
                {
                    (salesOrder.type === 'aligner-reproduction') && (
                        <tr>
                            <td>Aligner Label</td>
                            <td><a href={REPRODUCTION_ALIGNER_LABEL_URL + salesOrder.id} target="_blank" rel="noopener noreferrer">open</a></td>
                        </tr>
                    )
                }
                {
                    (salesOrder.type === 'retainer' || salesOrder.type === 'retainer-new' || salesOrder.type === 'retainer-refinement' || salesOrder.type === 'retainer-refinement-new') && (
                        <tr>
                            <td>Retainer Label</td>
                            <td><a href={RETAINER_LABEL_URL + salesOrder.id} target="_blank" rel="noopener noreferrer">open</a></td>
                        </tr>
                    )
                }
                {
                    (showInitialProcess) && (
                        <tr>
                            <td>Retainer model info</td>
                            {
                                ((salesOrder.type === 'retainer' || salesOrder.type === 'retainer-new') && hasPreviousRetainerRefinementProcess) && (
                                    <td>Retainer refinement</td>
                                )
                            }
                            {
                                ((salesOrder.type === 'retainer' || salesOrder.type === 'retainer-new') && !hasPreviousRetainerRefinementProcess) && (
                                    <td>Standart Retainer</td>
                                )
                            }
                            {
                                (salesOrder.type === 'retainer-refinement' || salesOrder.type === 'retainer-refinement-new') && (
                                    <td>Retainer refinement</td>
                                )
                            }
                        </tr>
                    )
                }
            </tbody>
        </table>
    )
}

SalesOrderProcessInfoTable.propTypes = {
    salesOrder: PropTypes.object.isRequired,
    showInitialProcess: PropTypes.bool,
    hasPreviousRetainerRefinementProcess: PropTypes.bool,
}

export default SalesOrderProcessInfoTable




// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/SalesOrderProcessInfoTable.js